export function createLead ({ leadType, leadTypeData, userId, leadCode, token }) {
  const lead = {
    lead_type: leadType,
    lead_type_data: leadTypeData,
    lead_code: leadCode
  };
  if (userId) { lead.user_id = userId }
  const authenticity_token = token || (token = document.querySelector('input[name="authenticity_token"]')?.value);

  $.post('/leads', { authenticity_token, lead });
}
